import {
  Button,
  Menu,
  MenuItemRadio,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from '@fluentui/react-components'
import { ChevronDown12Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useGetModels } from '../../hooks/useGetModels'
import type { ModelKey } from '../../types'
import { formatModelLabel } from '../../utils'

interface ModelSelectMenuProps {
  selectedModel: ModelKey
  onSelectedModelChange: (model: ModelKey) => void
  className?: string
}

export const ModelSelectMenu = ({
  selectedModel,
  onSelectedModelChange,
  className,
}: ModelSelectMenuProps) => {
  const { t } = useTranslation()
  const { data: modelOptions = [], isPending, isError } = useGetModels()

  const isLoadingInitialModels = isPending && modelOptions.length === 0
  const isModelMenuDisabled = isLoadingInitialModels || isError || modelOptions.length === 0

  return (
    <Menu
      checkedValues={{ model: [selectedModel] }}
      onCheckedValueChange={(_event, data) => {
        const nextModel = data.checkedItems[0]
        if (nextModel) {
          onSelectedModelChange(nextModel)
        }
      }}>
      <MenuTrigger disableButtonEnhancement>
        <Button
          className={className}
          appearance="subtle"
          size="small"
          disabled={isModelMenuDisabled}
          icon={<ChevronDown12Regular />}
          iconPosition="after"
          aria-label={t('chatInput.modelSelect')}>
          {modelOptions.find((option) => option.value === selectedModel)?.label ??
            formatModelLabel(selectedModel)}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {modelOptions.map((option) => (
            <MenuItemRadio key={option.value} name="model" value={option.value}>
              {option.label}
            </MenuItemRadio>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  )
}
